import jwtDecode from 'jwt-decode';
import { saveAs } from 'file-saver';

import apiClient from './apiClient';
import Enums from '../enums/enums';
import unescapeHtml from './unescapehtml';
import i18next from 'i18next';

const link = storedFileId => `${process.env.REACT_APP_API_BASE_URL}/media/${storedFileId}`;
const privateLink = storedFileId =>
  `${process.env.REACT_APP_API_BASE_URL}/media/private/${storedFileId}`;

const downloadStoredFile = async (storedFileId, callApi, forcedName) => {
  let fileName = 'unnamed';
  if (forcedName) {
    fileName = forcedName;
  } else {
    const storedFileInfo = await callApi(apiClient.getStoredFileInfo, [storedFileId]);
    fileName = storedFileInfo.name;
  }
  const blob = await callApi(apiClient.getBlob, [link(storedFileId)]);
  saveAs(blob, fileName, { autoBOM: true });
};

const downloadPrivateStoredFile = async (storedFileId, callApi, forcedName) => {
  let fileName = 'unnamed';
  if (forcedName) {
    fileName = forcedName;
  } else {
    const storedFileInfo = await callApi(apiClient.getStoredFileInfo, [storedFileId]);
    fileName = storedFileInfo.name;
  }
  const blob = await callApi(apiClient.getBlob, [privateLink(storedFileId)]);
  saveAs(blob, fileName, { autoBOM: true });
};

const escapeRegExp = str => str.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1');
const replaceAll = (str, find, replace) => str.replace(new RegExp(find, 'g'), replace);

const stringFormat = (string, values) =>
  string.replace(/{(\d+)}/g, (match, number) =>
    typeof values[number] !== 'undefined' ? values[number] : match
  );

const isValidDate = date => date instanceof Date && !Number.isNaN(date.valueOf());

const clearBearer = () => {
  sessionStorage.removeItem('sm-store');
};

const storeBearer = bearer => {
  const decodedAccessToken = jwtDecode(bearer.access_token);
  const expAt = new Date().getTime() + bearer.expires_in * 1000;
  sessionStorage.setItem(
    'sm-store',
    JSON.stringify({
      client: decodedAccessToken.clientToken,
      user: { userId: decodedAccessToken.userId },
      security: { ...bearer, expAt },
    })
  );
};

const isNodeMapped = () => !!sessionStorage.getItem('networknode');

const getDataListFromEnum = enumName => {
  const Enum = Enums[enumName];
  let dataList;
  switch (enumName) {
    case 'CivilityType':
      dataList = Object.keys(Enum).map(key => ({
        id: Enum[key],
        name: i18next.t(`smartmessaging.enums.civility.${key}`),
      }));
      break;
    case 'StatusType':
      dataList = Object.keys(Enum).map(key => ({
        id: Enum[key],
        name: i18next.t(`smartmessaging.enums.status.${key}`),
      }));
      break;
    default:
      dataList =
        (Enum &&
          Object.keys(Enum).map(key => ({
            id: Enum[key],
            name: i18next.t(`smartmessaging.enums.${enumName}.${key}`),
          }))) ||
        [];
  }
  return dataList;
};

const getNewDateWithTime = srtingHour => {
  if (srtingHour) {
    const date = new Date();
    const vals = srtingHour.split(':');
    date.setHours(vals[0]);
    date.setMinutes(vals[1]);
    return date;
  }
  return null;
};

const arrayDiff = (arrayA, arrayB) =>
  arrayA.reduce((diff, current) => {
    if (arrayB.indexOf(current) === -1) {
      return [...diff, current];
    }
    return diff;
  }, []);

const getCivilityLabel = (civObj, lang) => {
  // correspondances entre les locales venant de resa2 et celles utilisées sur SmartM avant la mise en commun
  // doit etre mis à jour en cas de changement
  // on retrouve ces correspondances en back dans l'ENUM LanguageEnum
  const correspondances = {
    'fr-FR': ['fr'],
    'es-ES': ['es'],
    'en-GB': ['en-GB'],
  };
  let label = null;
  correspondances[lang].forEach(cor => {
    if (label === null) {
      label = civObj.names[cor] || null;
    }
  });

  if (label === null) [label] = Object.values(civObj.names);
  return label;
};

export default {
  arrayDiff,
  clearBearer,
  downloadStoredFile,
  downloadPrivateStoredFile,
  getDataListFromEnum,
  getNewDateWithTime,
  isValidDate,
  link,
  privateLink,
  escapeRegExp,
  replaceAll,
  storeBearer,
  stringFormat,
  unescapeHtml,
  isNodeMapped,
  getCivilityLabel,
};
